import { render, staticRenderFns } from "./DraggableResizableCut.vue?vue&type=template&id=5aade7e6&scoped=true&"
import script from "./DraggableResizableCut.vue?vue&type=script&lang=js&"
export * from "./DraggableResizableCut.vue?vue&type=script&lang=js&"
import style0 from "./DraggableResizableCut.vue?vue&type=style&index=0&id=5aade7e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aade7e6",
  null
  
)

export default component.exports